(function($) { 
    var masthead,
        siteNavigationToggle,
        siteNavigationToggleLabel,
        siteNavigation,
        siteNavigationMenu,
        siteNavigationOverlay,
        siteNavigationText;

    masthead = $('#masthead');
    siteNavigation = masthead.find('.site-navigation');
    siteNavigationMenu = siteNavigation.find('.site-navigation__menu');
    siteNavigationToggle = siteNavigation.find('.site-navigation__toggle');
    siteNavigationToggleLabel = siteNavigationToggle.find('.site-navigation__toggle-label');
    siteNavigationText = {
        expand: mousyLocalize.openMenu,
        close: mousyLocalize.closeMenu,
        expandChild: mousyLocalize.expand,
        collapseChild: mousyLocalize.collapse,
    };

    // Add the overlay for closing the mobile menu
    // when tapping outside of the menu.
    siteNavigationOverlay = $('<div class="site-navigation__overlay"></div>');
    $('body').append(siteNavigationOverlay);

    function initSiteNavigation(container) {
        
        // Dropdown Button for the mobile menu
        var dropdownToggle = $('<button />', {'class': 'site-navigation__menu-dropdown-toggle', 'aria-expanded': false})
            .append( $('<span />', {'class': 'site-navigation__menu-dropdown-symbol', text: '+'}))
            .append( $('<span />', {'class': 'screen-reader-text', text: siteNavigationText.expandChild}));

        container.find('.menu-item-has-children > a').after(dropdownToggle);

        container.find('.site-navigation__menu-dropdown-toggle').click(function (e) {
            e.preventDefault();

            var _this = $(this),
                screenReaderSpan = _this.find('.screen-reader-text'),
                dropdownSymbol = _this.find('.site-navigation__menu-dropdown-symbol');
            dropdownSymbol.text(dropdownSymbol.text() === '-' ? '+' : '-');

            _this.toggleClass('toggled-on');
            var subMenu = _this.next('.sub-menu');
            subMenu.toggleClass('toggled-on');
            if (subMenu.hasClass('toggled-on')) {
              subMenu.show();
            } else {
              subMenu.hide();
            }
            
            if (_this.attr('aria-expanded') === 'false') {
                _this.attr('aria-expanded', 'true');
            }
            else {
                _this.attr('aria-expanded', 'false');
                _this.blur();
            }

            screenReaderSpan.text(screenReaderSpan.text() === siteNavigationText.expandChild ? siteNavigationText.collapseChild : siteNavigationText.expandChild);
        });
    }

    initSiteNavigation(siteNavigation);

    // Enable menu toggle
    (function() {
        // Return early if siteNavigationToggle is missing.
        if (!siteNavigationToggle.length) {
            return;
        }

        // Add an initial value for the aria-expanded attribute.
        siteNavigation.attr('aria-expanded', 'false');
        siteNavigationMenu.attr('aria-expanded', 'false');

        siteNavigationToggle.click(function () {
            toggleMenu();

            siteNavigationOverlay.one('click', function() {
                toggleMenu();
            });
        });
    })();

    function toggleMenu() {
        siteNavigation.toggleClass('toggled-on');
        $('body').toggleClass('menu-open');

        siteNavigationToggleLabel.text($.trim(siteNavigationToggleLabel.text() === siteNavigationText.expand ? siteNavigationText.close : siteNavigationText.expand));

        siteNavigation.attr(
            'aria-expanded',
            siteNavigation.attr('aria-expanded') === 'false' ? 'true' : 'false'
        );

        siteNavigationMenu.attr(
            'aria-expanded',
            siteNavigationMenu.attr('aria-expanded') === 'false' ? 'true' : 'false'
        );

        siteNavigationToggle.attr(
            'aria-expanded',
            siteNavigationToggle.attr('aria-expanded') === 'false' ? 'true' : 'false'
        );
    }

    // Fix sub-menus for touch devices and better focus for hidden submenu items for accessibility.
    (function () {
        if (!siteNavigationMenu.length || !siteNavigationMenu.children().length) {
            return;
        }

        // Toggle 'focus' class to allow submenu access on tablets.
        function toggleFocusClassTouchScreen() {
            if ($('.site-navigation__toggle').css('display') === 'none') {
                $(document.body).on('touchstart', function (e) {
                    if (!$(e.target).closest('.site-navigation li').length) {
                        $('.site-navigation li').removeClass('focus');
                    }
                });

                siteNavigationMenu.find('.site-navigation__menu-item.has-children > a')
                    .on('touchstart', function (e) {
                        var el = $(this).parent('li');

                        if (!el.hasClass('focus')) {
                            e.preventDefault();
                            el.toggleClass('focus');
                            el.siblings('.focus').removeClass('focus');
                        }
                    });
            }
            else {
                siteNavigationMenu.find('.menu-item.has-children > a').unbind('touchstart');
            }
        }

        if ('ontouchstart' in window) {
            $(window).on('resize', toggleFocusClassTouchScreen);
            toggleFocusClassTouchScreen();
        }

        siteNavigationMenu.find('a').on('focus blur', function () {
            $(this).parents('.menu-item').toggleClass('focus');
        });
    })();

    // Add the default ARIA attributes for the menu toggle and navigation on resize.
    function onResizeARIA() {
        if ($('.site-navigation__toggle').css('display') === 'flex') {
            if (siteNavigation.hasClass('toggled-on')) {
                siteNavigation.attr('aria-expanded', 'true');
                siteNavigationMenu.attr('aria-expanded', 'true');
                siteNavigationToggle.attr('aria-expanded', 'true');
                $('body').addClass('menu-open');
            }
            else {
                siteNavigation.attr('aria-expanded', 'false');
                siteNavigationMenu.attr('aria-expanded', 'false');
                siteNavigationToggle.attr('aria-expanded', 'false');
                $('body').removeClass('menu-open');
                siteNavigationOverlay.off('click');
            }
        }
        else {
            siteNavigation.removeClass('toggled-on');
            siteNavigation.removeAttr('aria-expanded');
            siteNavigationMenu.removeAttr('style');
            siteNavigationMenu.removeAttr('aria-expanded');
            siteNavigationToggle.removeAttr('aria-expanded');
            siteNavigationToggleLabel.text($.trim(siteNavigationText.expand));
            $('body').removeClass('menu-open');
        }
    }

    $(document).ready(function () {
        $(window).on('load', onResizeARIA);
        $(window).on('resize', onResizeARIA);
    });

})(jQuery);
